import React from "react";
import styles from "./Loading.module.css";

const Loading = ({ top, transparent, loading }) => (
  <div
    className={
      styles.loadingWrapper +
      " " +
      (top ? styles.top : "") +
      " " +
      (transparent ? styles.transparent : "")
    }
    style={{
      display: loading || typeof loading === "undefined" ? "flex" : "none",
    }}
  >
    {/* {console.log(typeofloading)} */}
    <i className={styles.loading}></i>
  </div>
);

export default Loading;
